import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import _isEmpty from 'lodash/isEmpty';
import { MstSentry } from '@zillow/mst-sentry';
import { sentryScope } from '../../../util/tracking';

import { DEFAULT_VERS, DISPLAY_AD_TYPE, VELOCITY_CONTROL_VERS } from '../constants';

import { getAdLoadSpeedTrial, getIsSecondNavAdSlot13Enabled } from '../util/getFromState';
import { getAdAbTrialVers } from '../util/common';
import SearchAd from './SearchAd';

export class DisplayAdContainer extends Component {
    constructor(props) {
        super(props);
        this.state = {
            wasMounted: false,
        };
    }

    componentDidMount() {
        this.setState({
            wasMounted: true,
        });
    }

    /**
     * We only want to update the Ad component if the response from the server indicates that we are in
     * need of a refresh
     */
    shouldComponentUpdate(nextProps) {
        return (
            nextProps.shouldUpdateAd ||
            !this.state.wasMounted ||
            this.props.adsConfig?.displayAdSlot !== nextProps.adsConfig?.displayAdSlot
        );
    }

    render() {
        const { adsConfig, adLoadSpeedTrial, hasBeenVisible, isSecondSlot13Enabled } = this.props;
        const isAdsConfigEmpty = _isEmpty(adsConfig) || _isEmpty(adsConfig.displayAdSlot);

        if (isAdsConfigEmpty) {
            return null;
        }

        const { displayAdSlot, targets } = adsConfig;

        const webSpeedVers = getAdAbTrialVers(
            'MST_SRP_WEB_SPEED',
            adLoadSpeedTrial,
            VELOCITY_CONTROL_VERS
        );
        const secondSlotVers = isSecondSlot13Enabled
            ? 'z_srp_web_2ndad-13and17_test_a'
            : 'z_srp_web_2ndad-13and17_test_b';
        const mstVers = `${DEFAULT_VERS},${webSpeedVers},${secondSlotVers}`;

        return (
            <div key="generic-display-ad" className="generic-display-ad-container">
                <SearchAd
                    adType={DISPLAY_AD_TYPE}
                    slot={displayAdSlot}
                    targets={targets}
                    renderAd={this.state.wasMounted}
                    targetDiv="srp_iab_slot_box_1"
                    variant="zsrp"
                    isPrebidTrialOn={true}
                    versOn={mstVers}
                    hasBeenVisible={hasBeenVisible}
                />
            </div>
        );
    }
}

DisplayAdContainer.propTypes = {
    adsConfig: PropTypes.object.isRequired,
    shouldUpdateAd: PropTypes.bool.isRequired,
    adLoadSpeedTrial: PropTypes.string,
    hasBeenVisible: PropTypes.bool,
};

const mapStateToProps = state => ({
    adsConfig: state.searchList.adsConfig,
    shouldUpdateAd: state.uiState.shouldUpdateNavAd,
    adLoadSpeedTrial: getAdLoadSpeedTrial(state),
    isSecondSlot13Enabled: getIsSecondNavAdSlot13Enabled(state),
});

const ConnectedDisplayAdContainer = connect(mapStateToProps)(DisplayAdContainer);

const DisplayAdErrorBoundary = props => (
    <MstSentry sentryScope={sentryScope}>
        <ConnectedDisplayAdContainer {...props} />
    </MstSentry>
);

export const _testHook = {
    mapStateToProps,
};

export default DisplayAdErrorBoundary;
